import { invalidateSidebarHitTestCache } from '../sidebarHitTest';

let pointerMoveListener = null;
let pointerUpListener = null;
let scrollInvalidateListener = null;

export function removePointerListeners() {
  if (pointerMoveListener) {
    document.removeEventListener('pointermove', pointerMoveListener, { capture: true });
    document.removeEventListener('mousemove', pointerMoveListener, { capture: true });
    pointerMoveListener = null;
  }
  if (pointerUpListener) {
    document.removeEventListener('pointerup', pointerUpListener, { capture: true });
    document.removeEventListener('mouseup', pointerUpListener, { capture: true });
    pointerUpListener = null;
  }
  if (scrollInvalidateListener) {
    document.removeEventListener('scroll', scrollInvalidateListener, { capture: true });
    window.removeEventListener('resize', scrollInvalidateListener);
    scrollInvalidateListener = null;
  }
}

export function attachPointerListeners(onPointerMove, onPointerUp) {
  removePointerListeners();

  pointerMoveListener = onPointerMove;
  // Final (release) coordinates must never CLEAR an already-locked drop target:
  // fast drops overshoot the row/sidebar by a few px between the last mousemove
  // and the mouseup, which used to wipe the target and cancel the drop.
  pointerUpListener = onPointerUp;
  // Sidebar scroll/expand or window resize moves rows — drop the cached rects
  scrollInvalidateListener = () => invalidateSidebarHitTestCache();

  document.addEventListener('pointermove', pointerMoveListener, { passive: true, capture: true });
  document.addEventListener('mousemove', pointerMoveListener, { passive: true, capture: true });
  document.addEventListener('pointerup', pointerUpListener, { passive: true, capture: true });
  document.addEventListener('mouseup', pointerUpListener, { passive: true, capture: true });
  document.addEventListener('scroll', scrollInvalidateListener, { passive: true, capture: true });
  window.addEventListener('resize', scrollInvalidateListener);
}
